<template>
<div class="bk-gray-dark  trick-5">
  <img src="../../../assets/images/preparare-formule/truc5.png" alt="/">
    <p>5. Mixează formula de lapte conform recomandărilor de pe ambalaj</p>
    <span>Ca să mixezi corect formula de lapte praf, agită recipientul de preparare vertical și viguros, timp de 10 secunde.
        În urma acestei proceduri poate apărea o cantitate de spumă. Este perfect normal și poate fi diminuată prin rotirea circulară în aer a
        recipientului de câteva ori. Indiferent de situație, spuma nu poate fi înghițită de către copil, aceasta ridicându-se permanent deasupra
        lichidului, atunci când recipientul este întors.</span>
</div>
</template>

<script>
export default {
    name: 'Mixare',
}
</script>
<style lang="scss" scoped>
.trick-5 p{
  margin-top: 50px;
  color: #17479E;
  font-size: 20px;
  font-weight: 600;
}

.trick-5 span{
  font-size: 16px;
  color: #17479e;
}

.trick-5 img {
  position: absolute;
  left: 20px;
  top: -60px;
}

.bk-blue-light {
    background: #F1F8FF;
    border-radius: 20px;
    padding-top: 65px;
    width: 420px !important;
    min-height: 380px;
    max-height: 380px;
    position: relative;
    @media only screen and (max-width: 992px) {
        width: 100% !important;
        max-height: 100%;
        min-height: auto;
        padding-top: 45px;
    }

    p {
        font-size: 16px;
        font-weight: 600;
        color: #029FE3;
    }

    span {
        font-size: 14px;
        font-weight: 500;
        color: #029FE3;
    }
}

@media screen and (max-width: 526px){
  .trick-5 img{
    width: 89px !important;
    height: 89px !important;
    top: -40px;
  }
}
</style>
